<div mat-dialog-content>
  <p>
    {{ 'igo.geo.draw.layer.layerDialogInstruction' | translate }}
  </p>
  <mat-form-field class="example-full-width">
    <input
      #input
      matInput
      placeholder="{{ 'igo.geo.draw.layer.title' | translate }}"
    />
  </mat-form-field>
</div>
<div mat-dialog-actions>
  <button matButton="elevated" (click)="cancelDrawing()">
    {{ 'igo.geo.draw.cancel' | translate }}
  </button>
  <button matButton="elevated" color="primary" (click)="confirm(input.value)">
    OK
  </button>
</div>
